import { useSelector } from "react-redux";
import * as EncryptedKey from '../constants/encryptedRootReducerKeys';

export const useAllSelector = () => {

	const switchPharmacyResponse = useSelector((state) => state[EncryptedKey.switchPharmacy]);
	const patientDataBasisOfRouteResponse = useSelector((state) => state[EncryptedKey.patientDataBasisOfRoute]);

	const patientDeliveredDataBasisOfRouteResponse = useSelector((state) => state[EncryptedKey.patientDeliveredDataBasisOfRoute]);
	const pharmacistOfPharmacyListResponse = useSelector((state) => state[EncryptedKey.pharmacistOfPharmacyList]);
	const driverDeliveredRouteListResponse = useSelector((state) => state[EncryptedKey.driverDeliveredRouteList]);

	const patientSearchListResponse = useSelector((state) => state.patientSearchList);
	const changePasswordResponse = useSelector((state) => state.changePassword);
	const changePasscodeResponse = useSelector((state) => state.changePasscode);
	const driverLogoutResponse = useSelector((state) => state.driverLogout);

	const patientDeliveryRxListResponse = useSelector((state) => state.patientDeliveryRxList);
	const patientPendingListResponse = useSelector((state) => state.patientPendingList);
	const confirmDeliveryResponse = useSelector((state) => state.confirmDelivery);

	const updateProfileResponse = useSelector((state) => state.updateProfile);
	const updateDeliveryListResponse = useSelector((state) => state.updateDeliveryList);

	const patientConsentResponse = useSelector((state) => state.patientConsent);
	const allPharmacyListResponse = useSelector((state) => state.allPharmacyList);

	const pharmacistDetail = pharmacistOfPharmacyListResponse?.data?.data?.pharmacist
	const driverDefaultPharmacist = pharmacistOfPharmacyListResponse?.data?.data?.driver_default_pharmacist
	const driverDefaultPharmacistId = pharmacistOfPharmacyListResponse?.data?.data?.driver_default_pharmacist_id
	const routeListResponse = pharmacistOfPharmacyListResponse?.data?.data?.route

	const pharmacyDetail = switchPharmacyResponse?.data?.data

	const deliveredRoutes = driverDeliveredRouteListResponse?.data?.data || [];
	const todaysDispenseList = patientDataBasisOfRouteResponse?.data

	const deliveredCount = pharmacistOfPharmacyListResponse?.data?.data?.delivered_count

	const patientRxData = patientDeliveryRxListResponse?.data?.data?.patient

	const todaysAnalyticsResponse = useSelector(state => state?.todaysAnalytics)

	const UploadPrescripitionResponse = useSelector(state => state.UploadPrescripition)
	const updatePatientProfileResponse = useSelector(state => state.updatePatientProfile)

	const validateReturnedPatchesResponse = useSelector(state => state.validateReturnedPatches)

	const UploadedTriplicatesPatientSignResponse = useSelector(state => state.UploadedTriplicatesPatientSign)
	const GenrateRxLinkResponse = useSelector(state => state.GenrateRxLink)

	const flexiDeliverResponse = useSelector(state => state.flexiDeliver)
	const redBagResponse = useSelector(state => state.redBag)

	return {
		switchPharmacyResponse,
		changePasswordResponse,
		changePasscodeResponse,

		driverLogoutResponse,
		routeListResponse,
		patientDataBasisOfRouteResponse,
		patientDeliveredDataBasisOfRouteResponse,

		patientSearchListResponse,
		pharmacistOfPharmacyListResponse,
		patientDeliveryRxListResponse,

		patientPendingListResponse,
		confirmDeliveryResponse,
		updateProfileResponse,

		updateDeliveryListResponse,

		driverDeliveredRouteListResponse,
		patientConsentResponse,
		allPharmacyListResponse,

		pharmacyDetail,
		pharmacistDetail,
		driverDefaultPharmacist,
		driverDefaultPharmacistId,
		deliveredRoutes,
		todaysDispenseList,

		deliveredCount,
		patientRxData,
		todaysAnalyticsResponse,
		UploadPrescripitionResponse,
		updatePatientProfileResponse,
		validateReturnedPatchesResponse,
		UploadedTriplicatesPatientSignResponse,
		GenrateRxLinkResponse,
		flexiDeliverResponse,
		redBagResponse
	}
}
